import { useQuery } from "@apollo/client";
import { GET_MY_SETTINGS } from "../api/get-my-settings";
import { useIsUserAuthenticated } from "../../user/model/user-context";
import { usePersonLanguageMutation } from "./use-person-language-mutation";
import { useLocale } from "@/shared/i18n";

export function useMySettingsData() {
  const isUserAuthenticated = useIsUserAuthenticated();
  const { locale } = useLocale();
  const { save } = usePersonLanguageMutation();

  const { data } = useQuery(GET_MY_SETTINGS, {
    skip: !isUserAuthenticated,
    onCompleted: async (data) => {
      if (data.getMySettings?.primaryLanguage?.toLowerCase() !== locale) {
        await save(locale);
      }
    },
  });

  const settings = data?.getMySettings;

  return {
    settings,
  };
}
